<template>
    <section class="top-menu">
        <div>
            <b-nav tabs ref="topMenu">
                <b-nav-item :to="{name: 'settings'}" :active="this.$router.currentRoute.name == 'settings'">Переменные</b-nav-item>
                <b-nav-item :to="{name: 'googleAccount'}" :active="this.$router.currentRoute.name == 'googleAccount'">Google акаунты</b-nav-item>
                <b-nav-item :to="{name: 'demandCountries'}" :active="this.$router.currentRoute.name == 'demandCountries'">Страны анализа спроса</b-nav-item>
                <b-nav-item :to="{name: 'emailAlert'}" :active="this.$router.currentRoute.name == 'emailAlert'">Емейл-оповещения</b-nav-item>
                <b-nav-item :to="{name: 'countries'}" :active="this.$router.currentRoute.name == 'countries'">Страны</b-nav-item>
                <b-nav-item :to="{name: 'languages'}" :active="this.$router.currentRoute.name == 'languages'">Языки</b-nav-item>
            </b-nav>
        </div>
    </section>
</template>

<script>
    export default {
        name: "TopMenu"
    }
</script>

<style scoped>
    .top-menu {
        margin-bottom: 20px;
    }
</style>